// Connection accounting: per-worker inflight caps and the node-wide
// data-plane connection gauge.

export const createInflightTracker = (cap: number) => {
  const counts = new Map<string, number>();
  return {
    acquire: (sessionId: string): (() => void) | null => {
      const held = counts.get(sessionId) ?? 0;
      if (held >= cap) return null;
      counts.set(sessionId, held + 1);
      let released = false;
      return () => {
        if (released) return;
        released = true;
        const left = counts.get(sessionId)! - 1;
        if (left === 0) counts.delete(sessionId);
        else counts.set(sessionId, left);
      };
    },
  };
};

export const createConnectionTracker = (gauge: {
  inc(): void;
  dec(): void;
}) => {
  let active = 0;
  return {
    acquire: (): (() => void) => {
      active += 1;
      gauge.inc();
      let released = false;
      return () => {
        if (released) return;
        released = true;
        active -= 1;
        gauge.dec();
      };
    },
    count: () => active,
  };
};
